// utils/cookieUtils.js

// Fungsi untuk mengambil nilai cookie berdasarkan namanya
export const getCookie = (name) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }
  